import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FuelHourlyConsumptionChartComponent } from './fuel-hourly-consumption-chart.component';
import {DxChartModule} from 'devextreme-angular';
import {DxoValueAxisModule} from 'devextreme-angular/ui/nested';



@NgModule({
  declarations: [FuelHourlyConsumptionChartComponent],
  imports: [
    CommonModule,
    DxChartModule,
    DxoValueAxisModule
  ],
  exports: [FuelHourlyConsumptionChartComponent]
})
export class FuelHourlyConsumptionChartModule { }
